import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { DeviceMetadata, EdgeDevice } from '@api';
import { TranslationService } from '../../transloco/services/translation.service';
import { getRemainingActiveLiveData } from './live-data-activation.extensions';

@Component({
    selector: 'app-live-data-activation',
    templateUrl: './live-data-activation.component.html',
    styleUrls: ['./live-data-activation.component.scss'],
    standalone: false,
})
export class LiveDataActivationComponent {
    private _edgeDevice: EdgeDevice;
    private translationService = inject(TranslationService);

    @Input() public set edgeDevice(value: EdgeDevice) {
        this._edgeDevice = value;
        this.isSelectedDeviceOffline = this._edgeDevice?.deviceStatus !== 1;
        this.isLiveDataActivated = this._edgeDevice?.isLiveDataEnabled === true;
    }

    @Output() public toggleLiveDataChanged = new EventEmitter<DeviceMetadata>();

    public isSelectedDeviceOffline: boolean;
    public isLiveDataActivated: boolean;

    public get getRemainingActiveLiveData() {
        return getRemainingActiveLiveData(this.translationService, this._edgeDevice);
    }

    public toggleLiveData(isEnabled: boolean | number) {
        const deviceMetadata = { ...this._edgeDevice, isLiveDataEnabled: !!isEnabled } as DeviceMetadata;
        this.toggleLiveDataChanged.emit(deviceMetadata);
    }
}
